import React from 'react';
import { Account20 } from '@carbon/icons-react';

import type { Product } from '#config/products';
import LegacyAppLayout from '#coreComponents/LegacyAppLayout';
import type Products from '.';
import SupportMessageInProduct from '#coreComponents/SupportMessageInProduct/SupportMessageInProduct';

const productPage = (productName: keyof typeof Products) => async () => {
  // this cannot be a param, dont try to make this function generic
  const products = (await import('.')).default;
  return {
    default: products[productName],
  };
};

const Overview = React.lazy(productPage('Overview'));
const VotingAnalysis = React.lazy(productPage('VotingAnalysis'));
const AcademicInsights = React.lazy(productPage('AcademicInsights'));
const Peers = React.lazy(productPage('Peers'));
const Country = React.lazy(productPage('Country'));
const NationalVsInternational = React.lazy(
  productPage('NationalVsInternational'),
);
const SubjectBreakdown = React.lazy(productPage('SubjectBreakdown'));
const NetworkAnalysis = React.lazy(productPage('NetworkAnalysis'));

const reputationConfig: Product = {
  name: 'Reputation',
  authKey: 'reputation',
  description:
    'Understand the strength of your university’s brand and reputation, globally',
  path: 'reputation',
  icon: Account20,
  color: 'electricViolet',
  usesLegacyPermissions: true,
  featureFlagId: 'reputation',
  disabledFeatureComponent: () => (
    <SupportMessageInProduct productName="Reputation" />
  ),
  productConfig: {
    topbar: {
      title: 'Reputation',
      titleAcronym: 'Rep',
      rank: '1',
      filter: {
        hasPeerSelector: true,
        hasQueryBuilder: false,
      },
    },
  },
  pages: [
    {
      name: 'Overview',
      path: 'overview',
      component: Overview,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Voting Analysis',
      path: 'voting-analysis',
      component: VotingAnalysis,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Academic Insights',
      path: 'academic-insights',
      component: AcademicInsights,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Peers',
      path: 'peers',
      component: Peers,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Country',
      path: 'country',
      component: Country,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'National VS International',
      path: 'national-vs-international',
      component: NationalVsInternational,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Subject Breakdown',
      path: 'subject-breakdown',
      component: SubjectBreakdown,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Network Analysis',
      path: 'network-analysis',
      component: NetworkAnalysis,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
  ],
};

export default reputationConfig;
